// const VistaUsuariosAbmDetalle = () =>  import('Modules/administracion/usuarios/views/UsuariosAbmDetalle')
const VistaPacientesListado = () => import('Modules/pacientes/pacientes/views/PacientesListado')
const VistaPacientesDetalle = () => import('Modules/pacientes/pacientes/views/PacientesDetalle')

const rutas = [
  {
    name: 'pacientes',
    component: VistaPacientesListado,
    path: '/pacientes/busqueda',
    meta: {
      requiresAuth: true,
      title: 'Listado de pacientes',
      breadcrumb: null,
      menu: 'pacientes'
    }
  },
  {
    name: 'pacientes:ver',
    component: VistaPacientesDetalle,
    path: '/pacientes/ver/:id',
    props: {
      titulo: 'Ver',
      operacion: 'lectura'
    },
    meta: {
      requiresAuth: true,
      title: 'Ver',
      breadcrumb: null,
      menu: 'pacientes'
    }
  }
]

export default rutas
